<template>
</template>
<script>
export default {
    beforeCreate() {
        // 이니시스 복귀(/api/plugins/wpay/auth/:orderNo) → 서버 redirect 로 이 페이지가 결제창(새창) 안에서 열린다.
        // 오프너의 wpayComplete 로 결과(query)를 넘긴 뒤 창을 닫는다.
        opener?.window?.wpayComplete?.(this.$route.query);
        parent?.window?.wpayComplete?.(this.$route.query);
        if (opener || parent) window.close();
    },
};
</script>
